import { Button, CircularProgress, ButtonProps } from "@mui/material";
import React from "react";

interface LoadingButtonProps extends Omit<ButtonProps, 'startIcon'> {
  loading?: boolean;
  startIcon?: React.ReactNode;
}

const LoadingButton = ({
  children,
  loading = false,
  variant = "text",
  startIcon,
  onClick,
  ...props
}: LoadingButtonProps) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      disabled={loading || props.disabled}
      startIcon={
        loading ? <CircularProgress size={20} color="inherit" /> : startIcon
      }
      {...props}
    >
      {children}
    </Button>
  );
};

export default LoadingButton;
